/** @format */

import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box, Button } from '@mui/material';
//
import { BaseOptionChart } from '../../components/charts';
import moment from 'moment';
// import {Link as RouterLink} from "react-router-dom";
// import Iconify from "../../components/Iconify";
import React from 'react';
import _ from 'lodash';

// ----------------------------------------------------------------------

export default function AppWebsiteVisits(props) {
  const { labels, values, granularity } = props;
  // console.log("CHART1");
  // console.log(labels, values);

  let dateFormat = 'DD MMM YYYY';

  if (granularity === 'DAY') {
    dateFormat = 'DD MMM';
  } else if (granularity === 'MONTH') {
    dateFormat = 'MMM YYYY';
  }

  const chartOptions = merge(BaseOptionChart(), {
    // stroke: {width: [2, 2, 2], curve : "straight"},
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: 'rounded',
      },
    },
    fill: { type: ['solid', 'solid', 'solid'] },
    labels: labels,
    xaxis: {
      // type: "datetime",
      categories: labels,
      labels: {
        // format: 'dd MMM HH:mm',
        formatter: function (y) {
          return new moment(y).format(dateFormat);
        },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      x: {
        show: true,
        formatter: function (y) {
          return new moment(y).format(dateFormat);
        },
      },
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)}`;
          }
          return y;
        },
      },
      items: {
        display: 'flex',
      },
    },
  });

  const CHART_DATA = [
    {
      name: 'Sent',
      type: 'bar',
      data: values.map((obj) => obj.sent),
    },
    {
      name: 'Delivered',
      type: 'bar',
      data: values.map((obj) => obj.delivered),
    },
  ];

  const downloadData = async () => {
    let unzippedMessagesData = [];
    for (let idx in labels) {
      unzippedMessagesData.push({
        label: labels[idx],
        values: values[idx],
      });
    }
    // console.log(unzippedMessagesData);

    const convertToDate = (param) => {
      let momentDate = moment(param.label);
      momentDate.set({ hour: 10, minute: 0 });
      return momentDate.format('DD MMM YYYY');
    };

    let groupedMessageData = _.groupBy(unzippedMessagesData, convertToDate);
    // console.log(groupedMessageData);

    let resultJSON = [];

    for (let rawDate of Object.keys(groupedMessageData)) {
      let dayData = groupedMessageData[rawDate];
      let sentTotal = 0;
      let deliveredTotal = 0;
      // let readTotal = 0;
      for (let datum of dayData) {
        sentTotal += datum.values.sent;
        deliveredTotal += datum.values.delivered;
        // readTotal += datum.values.read;
      }
      resultJSON.push({
        date: rawDate,
        sent: sentTotal,
        delivered: deliveredTotal,
        // read: readTotal,
      });
    }

    let header = 'date;sent;delivered';
    // let header = "date;sent;delivered;read";
    let body = '';

    for (let rj of resultJSON) {
      // body += `\n${rj.date};${rj.sent};${rj.delivered};${rj.read}`;
      body += `\n${rj.date};${rj.sent};${rj.delivered}`;
    }

    let csvText = header + body;

    const element = document.createElement('a');
    const file = new Blob([csvText], { type: 'text/csv;charset=utf-8' });
    element.href = URL.createObjectURL(file);
    element.download = 'message_data_export.csv';
    document.body.appendChild(element);
    element.click();
  };

  // console.log("CHART_DATA", CHART_DATA);

  return (
    <Card>
      <CardHeader title="Messages" />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          paddingRight: 20,
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            downloadData();
          }}
        >
          Download
        </Button>
      </div>

      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={CHART_DATA}
          options={chartOptions}
          height={364}
        />
      </Box>
    </Card>
  );
}
